import {
  DYNAMIC_CONTENTS_LIST,
  DYNAMIC_CONTENT_VIEW,
  DYNAMIC_CONTENT_ADD,
  DYNAMIC_CONTENT_EDIT,
} from './type';

const initialState = {
  listData: { contents: [], pagination: {} },
  contentView: null,
  addResult: null,
  editResult: null,
};

export default function dynamicContentsReducer(state = initialState, action) {
  switch (action.type) {
    case DYNAMIC_CONTENTS_LIST:
      return { ...state, listData: action.payload };
    case DYNAMIC_CONTENT_VIEW:
      return { ...state, contentView: action.payload };
    case DYNAMIC_CONTENT_ADD:
      return { ...state, addResult: action.payload };
    case DYNAMIC_CONTENT_EDIT:
      return { ...state, editResult: action.payload };
    default:
      return state;
  }
}
